import img1 from "./WhatsApp Image 2025-11-25 at 4.01.37 PM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-25 at 4.01.37 PM (2).jpeg";
import img3 from "./WhatsApp Image 2025-11-25 at 4.01.37 PM.jpeg";
import img4 from "./WhatsApp Image 2025-11-25 at 4.01.38 PM (1).jpeg";
import img5 from "./WhatsApp Image 2025-11-25 at 4.01.38 PM.jpeg";
import img6 from "./WhatsApp Image 2025-11-25 at 4.01.39 PM (1).jpeg";
import img7 from "./WhatsApp Image 2025-11-25 at 4.01.39 PM (2).jpeg";
import img8 from "./WhatsApp Image 2025-11-25 at 4.01.39 PM.jpeg";
import img9 from "./WhatsApp Image 2025-11-25 at 4.01.40 PM (1).jpeg";
import img10 from "./WhatsApp Image 2025-11-25 at 4.01.40 PM.jpeg";
import img11 from "./WhatsApp Image 2025-11-25 at 4.01.41 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
];
